// extracted by mini-css-extract-plugin
export default {"spacing":"zLDT21"};